import type { CountryStatus } from '../types/ioda';

function escapeCsv(s: string | number): string {
  const t = String(s);
  if (/[",\n]/.test(t)) return `"${t.replace(/"/g, '""')}"`;
  return t;
}

function statusExportLabel(s: CountryStatus | null): string {
  if (!s) return '';
  if (s.currentStatus === 'major_outage') return 'OUTAGE';
  if (s.currentStatus === 'degraded') return 'DEGRADED';
  return 'NORMAL';
}

export function buildConnectivityCsv(
  chartData: { timestamp: number; value: number }[],
  status: CountryStatus | null,
  activeIsps: string[],
  mlRiskLabel: string | null
): string {
  const header = ['timestamp_utc', 'connectivity_pct', 'status', 'connectivity_display', 'active_isps', 'ml_risk_note'];
  const isps = activeIsps.filter(Boolean).slice(0, 12).join('; ');
  const st = statusExportLabel(status);
  const disp = status?.connectivity ?? '';
  const rows = chartData.map((row) => {
    const iso = new Date(row.timestamp).toISOString();
    return [iso, row.value.toFixed(2), st, disp, isps, mlRiskLabel ?? ''].map(escapeCsv).join(',');
  });
  return [header.join(','), ...rows].join('\n');
}

export function downloadCsv(content: string, filename: string) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
